/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'; // iui-utils
import { buttonStyles } from 'utils/themeV2';



/* ++++++++++ --------------- EXPORT : MY PROFILE : STYLES --------------- ++++++++++ */
export default theme =>({
    myprofile:{
        '& .name-page-copy': {
            opacity: '0',
            animationName: 'fadeInUp',
            animationDuration: '.2s',
            animationFillMode: 'forwards',
            animationDelay: '.1s',
        },
        '& .name-page-details': {
            opacity: '0',
            animationName: 'fadeInUp',
            animationDuration: '.2s',
            animationFillMode: 'forwards',
            animationDelay: '.175s',
        },

        // forms
        '& .form': {
            '& .griditem':{
                '& .text':{
                    width: pxToEm(200),
                    color: theme.color.primary.medium.swatch
                },
                '&.name-change-password': {
                    paddingTop: pxToEm(35)
                }
            }
        },
        ...buttonStyles
    }
});
